import * as Blockly from 'blockly/core';
import { blockWhile } from '@/(routers)/boards/editor/block/generators/arduino/_gen';

export function register(gen: any): void {
    gen.forBlock['while'] = function (block: Blockly.Block): string {
        const cond = gen.valueToCode(block, 'CONDITION', 0) || '0';
        const body = gen.statementToCode(block, 'DO') || '';
        return blockWhile(cond, body);
    };
}
